import {RecentAbstractView} from "../view/RecentAbstractView";
import {RecentMemberView} from "../view/RecentMemberView";
import {RecentPartnerRfpView} from "../view/RecentPartnerRfpView";
import {MessageUtil} from "../../../utils/MessageUtil";
import {PartnerRfpUtils} from "../../PartnerRfpModel/PartnerRfpUtils";

export class RecentAbstractUtil {

    /**
     * Obtient le libellé d'affichage pour un élément de l'historique
     * @param item L'élément de l'historique
     * @returns Le libellé à afficher
     */
    static getRecentItemDisplayLabel(item: RecentAbstractView): string {
        if (item instanceof RecentMemberView) { // TYPE_USER
            // Priorité : Nom de l'entreprise, sinon prénom + nom, sinon "Unknown User"
            if (item.memberCompanyName && item.memberCompanyName.trim()) {
                return item.memberCompanyName;
            }
            const fullName = `${item.memberFirstName || ''} ${item.memberLastName || ''}`.trim();
            return fullName || 'Unknown User';
        } else if (item instanceof RecentPartnerRfpView) { // TYPE_PARTNERRFP
            return MessageUtil.getMessage(item.businessName) + ` #${item.partnerRfpId || item.id}`;
        }

        return 'Unknown Item';
    }

    /**
     * Obtient le lien de navigation pour un élément de l'historique
     * @param item L'élément de l'historique
     * @returns Le lien de navigation
     */
    static getRecentItemNavigationLink(item: RecentAbstractView): string {
        if (item instanceof RecentMemberView) { // TYPE_USER
            return `/user/${item.memberId}/general`;
        } else if (item instanceof RecentPartnerRfpView) { // TYPE_PARTNERRFP
            return PartnerRfpUtils.getEditLink(item.partnerRfpId);
        }
        return "";
    }
}